import React from 'react';
import { NCZIPatientContact } from '../../../../Interfaces/ncziPatientInformations';
import { StornoPatientSummaryContactInformation } from '../../../../Commands/StornoPatientSummaryContactInformation';
import NCZICommandResult from '../../../NCZICommandResult/NCZICommandResult';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import useNCZICommandProcess from '../../../../Hooks/useNCZICommandProcess';
import NZCIListItem from '../../../Base/NZCIListItem';
import { FormattedDateTime } from '../../../../../../Components/FormattedDate';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';

//@ts-ignore
import styles from './ElectronicHealthCardInfoContact.module.scss';

interface Props {
	data: NCZIPatientContact | undefined;
	patientIdentifier: string;
	handleReloadData?: () => void;
	handleEdit: () => void;
	patientName?: string;
}

const ElectronicHealthCardInfoContact: React.FC<Props> = ({
	data,
	patientIdentifier,
	handleReloadData,
	handleEdit,
	patientName,
}) => {
	const { processingCommandId, processCommand, isProcessing } =
		useNCZICommandProcess({
			onFinish: () => handleReloadData?.(),
		});

	const handleStornoRecord = async () => {
		const stornoCommand = StornoPatientSummaryContactInformation({
			patientCode: patientIdentifier,
			recordIds: [data?.rcId!],
		});

		await processCommand(stornoCommand);
	};

	if (isProcessing && processingCommandId) {
		return <NCZICommandResult commandId={processingCommandId} />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<LinkButton
					title={'Upravit kontaktní údaje'}
					theme={Theme.BLUE}
					onClick={() => handleEdit()}
				/>
				{data && (
					<LinkButton
						title={'nczi.action.cancelLastChanges'}
						theme={Theme.RED}
						onClick={() => handleStornoRecord()}
					/>
				)}
			</div>
			<ScrollContainer>
				{data && (
					<div className={styles.content}>
						{patientName && <div className={styles.header}>{patientName}</div>}
						{data.createdAt && (
							<NZCIListItem
								title='nczi.createdAt'
								value={<FormattedDateTime datetime={data.createdAt} />}
								align
							/>
						)}
						{data.email && (
							<NZCIListItem
								title='base.shared.email'
								value={data.email}
								align
							/>
						)}
						{data.phone && (
							<NZCIListItem
								title='base.shared.phone'
								value={data.phone}
								align
							/>
						)}
						{data.note && (
							<NZCIListItem title='base.internalNote' value={data.note} align />
						)}
						{data.address && (
							<NZCIListItem
								title='base.addressOfLiving'
								value={data.address.descriptiveNumber}
								align
							/>
						)}
						{data.address?.city?.displayName && (
							<NZCIListItem
								title='base.shared.city'
								value={data.address.city.displayName}
								align
							/>
						)}
						{data.address?.district?.displayName && (
							<NZCIListItem
								title='component.nczi.ezk.district'
								value={data.address.district.displayName}
								align
							/>
						)}
						{data.address?.region?.displayName && (
							<NZCIListItem
								title='component.nczi.ezk.region'
								value={data.address.region.displayName}
								align
							/>
						)}
						{data.address?.postCode?.displayName && (
							<NZCIListItem
								title='base.shared.postCode'
								value={data.address.postCode.displayName}
								align
							/>
						)}
					</div>
				)}
			</ScrollContainer>
		</div>
	);
};

export default ElectronicHealthCardInfoContact;
